<div class="card-white">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">ABC Empresas</h2>
    </div>
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P101K0001" />
      </div>
      <button mat-flat-button class="btn-new" (click)="nuevo()" [appPermissionControl]="'P101B0001'" appPermissionControl="P101B0004">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    [globalFilterFields]="['sEmpresa', 'sNombre', 'sRfc']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P101T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P101C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" (click)="editar(rowData)" pTooltip="Editar" appPermissionControl="P101B0002"></button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="delete(rowData)" pTooltip="Eliminar" appPermissionControl="P101B0003"></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>
